export default {
    getName(list){
        if(!list){
            return 'no name'
        }
        if(!Array.isArray(list)){
            return '---'
        }
        const localeTemp = (localStorage.getItem('locale') || 'ES').toUpperCase();
        return (list.find(a=>a.locale === localeTemp && a.field === 'NAME') || {value:'no data'}).value;
    },
    getField(list, field){
        if(!list){
            return 'no name'
        }
        if(Array.isArray(list)){
            const localeTemp = (localStorage.getItem('locale') || 'ES').toUpperCase();
            return (list.find(a=>a.locale === localeTemp && a.field === field) || {value:'--'}).value;
        }
        else '--'
    }
}